import { DownloadButtonStyled } from './download-button.styled'

export const DownloadButton = (props: any) => {
  return (
    <DownloadButtonStyled {...props}>{props.children}</DownloadButtonStyled>
  )
}
